import type React from 'react'
import type { IconProps } from './types'

const Text: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M7 20V7H2V4H15V7H10V20H7ZM16 20V12H13V9H22V12H19V20H16Z' />
	</svg>
)

export default Text
